module.exports = __webpack_public_path__ + "img/karneval.2589a303.jpg";